const ADMIN_ROLE_IDS = new Set([1, 3]);

export function isAdminRole(user?: { role?: { id?: number | null } } | null): boolean {
  return ADMIN_ROLE_IDS.has(user?.role?.id ?? -1);
}
